<a class="nav-link" (click)="showAboutDialog()">
  <i class="fa fa-copyright"></i>
  {{'Header.About' | i18next}} 
</a>
